import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PagePath } from '@monorepo/client-types';
import { PurchaseStatus } from '@monorepo/types';
import { URL_PARAMS } from '@hub/features/account-dashboard/constants/account-dashboard.constants';
import { useStore } from '@hub/helpers/use-store';

/**
 * Custom hook to check for recently created accounts and redirect to the most recent one
 * Checks for accounts created in the last 30 seconds on initialization
 */
export const useRecentAccountCheck = (
  purchaseId: string | undefined,
  status: PurchaseStatus | undefined,
) => {
  const navigate = useNavigate();
  const [accountCheckCompleted, setAccountCheckCompleted] = useState(false);

  const {
    dataStore: { accountStore },
  } = useStore();

  useEffect(() => {
    const checkForNewAccounts = async () => {
      if (
        accountCheckCompleted ||
        !purchaseId ||
        status !== PurchaseStatus.Completed
      ) {
        return;
      }

      try {
        const { tsAccountId } =
          await accountStore.getByPurchaseUniqId(purchaseId);
        if (tsAccountId) {
          // Redirect immediately to the account overview
          if (tsAccountId) {
            setTimeout(() => {
              navigate(
                `${PagePath.Overview}/${tsAccountId}?${URL_PARAMS.THANK_YOU}`,
              );
            }, 2000);
            return;
          }
        }
      } catch (error) {
        console.error('Failed to check for new accounts:', error);
        // Don't show error to user, just continue with normal flow
      } finally {
        setAccountCheckCompleted(true);
      }
    };

    checkForNewAccounts();
  }, [purchaseId, status]); // Empty dependency array - run only once on initialization

  return {
    accountCheckCompleted,
  };
};
